import { Button, Dialog, DialogActions, DialogContent, Divider, Grid, Typography } from '@material-ui/core'
import { Checkbox } from '@mui/material'
import { useState } from 'react'
import { EmLevel, TruncatedTags } from '../../core'
import { EmInterventionsApi } from './em-interventions-api'

function toggleLevel(level: EmLevel, checked: boolean, list: EmLevel[]) {
  if (checked) {
    list.push(level)
  } else {
    const existing = list.find((v) => v === level)
    if (existing) {
      list.splice(list.indexOf(existing), 1)
    }
  }
}

const listLabel = (a: EmLevel) => a.emLevel + ' - ' + a.description

function EmInterventionsGrid({ api, close }: EmInterventionsProps & { close: () => void }) {
  const { config, form } = api
  const { severities, interventions } = config
  const [render, setRender] = useState(false)

  const onSeverityChange = (level: EmLevel) => {
    return (_, checked) => {
      level.selected = checked
      const values = form.controls.severities.value.getState().value || []
      toggleLevel(level, checked, values)

      form.controls.severities.setValue(values)
      setRender(!render)
    }
  }
  const onInterventionChange = (value: EmLevel) => {
    return (_, checked) => {
      value.selected = checked
      const values = form.controls.interventions.value.getState().value || []
      toggleLevel(value, checked, values)
      form.controls.interventions.setValue(values)
      setRender(!render)
    }
  }

  return (
    <Dialog open={true}>
      <DialogContent>
        <Grid container xs={12} direction="row" style={{ flexWrap: 'nowrap' }}>
          <Grid container item direction="column" spacing={2} xs={6}>
            <Grid item>
              <Typography variant="overline">Severities</Typography>
            </Grid>
            <Grid
              container
              item
              direction="column"
              spacing={0}
              style={{ flexWrap: 'nowrap', overflowY: 'auto', maxHeight: '70vh' }}
            >
              {severities.map((level) => (
                <Grid
                  item
                  container
                  direction="row"
                  alignItems="flex-start"
                  style={{ flexWrap: 'nowrap', paddingTop: 12 }}
                >
                  <Grid item>
                    <Checkbox style={{ color: 'white' }} checked={level.selected} onChange={onSeverityChange(level)} />
                  </Grid>
                  <Grid item>
                    <div
                      style={{
                        color: 'white',
                        fontSize: 11,
                        width: 200,
                        whiteSpace: 'normal',
                      }}
                    >
                      {listLabel(level)}
                    </div>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Divider orientation="vertical" variant="middle" flexItem />
          <Grid container item direction="column" spacing={2} xs={6}>
            <Grid item>
              <Typography variant="overline">Interventions</Typography>
            </Grid>
            <Grid
              container
              item
              direction="column"
              spacing={0}
              style={{ flexWrap: 'nowrap', overflowY: 'auto', maxHeight: '70vh' }}
            >
              {interventions.map((level) => (
                <Grid item container direction="row" alignItems="center" style={{ flexWrap: 'nowrap', marginTop: -6 }}>
                  <Grid item>
                    <Checkbox
                      style={{ color: 'white' }}
                      checked={level.selected}
                      onChange={onInterventionChange(level)}
                    />
                  </Grid>
                  <Grid item container>
                    <div
                      style={{
                        color: 'white',
                        fontSize: 11,
                        width: 200,
                        whiteSpace: 'normal',
                      }}
                    >
                      {listLabel(level)}
                    </div>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ paddingBottom: 12 }}>
        <Button
          size="small"
          onClick={() => close()}
          variant="outlined"
          style={{
            color: 'white',
            border: '1px solid white',
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

type EmInterventionsProps = {
  api: EmInterventionsApi
}

export function EmInterventions({ api }: EmInterventionsProps) {
  const { form } = api

  const { severities, interventions } = form.controls

  const [open, setOpen] = useState(false)

  return (
    <>
      <Grid container direction="row" spacing={2} xs={12} style={{ width: '100%', flexWrap: 'nowrap' }}>
        <Grid container item direction="column" xs={6}>
          <Grid item>
            <Typography variant="overline">Severities</Typography>
          </Grid>
          <Grid item>
            <TruncatedTags {...severities} />
          </Grid>
        </Grid>
        <Grid container item direction="column" xs={6}>
          <Grid item container direction="row">
            <Typography variant="overline">Interventions</Typography>
            <Grid item style={{ flexGrow: 1 }} />
            <Grid item>
              <Button
                size="small"
                variant="outlined"
                onClick={() => setOpen(true)}
                style={{
                  marginTop: -12,
                  color: 'white',
                  border: '1px solid white',
                }}
              >
                Show Form
              </Button>
            </Grid>
          </Grid>
          <Grid item>
            <TruncatedTags {...interventions} />
          </Grid>
        </Grid>
      </Grid>
      {open && <EmInterventionsGrid api={api} close={() => setOpen(false)} />}
    </>
  )
}
